export default __webpack_public_path__ + "static/media/i144vp.6d22c88e.webp";